
const User = (api: any) => ({
  login: (username: string, password: string) =>
    api.login(username, password),
  logout: () =>
    api.logout(),
  fetchUser: (searchUser: {fullName: string, email: string, mobile: string , stateId: number | null, pageSize: number, pageNumber: number})=> api.post('/user/searchUser.php',{}, searchUser),
});

export default User;